import BaseComponent from "../../base/base_component";

export default class LastLoginComponentWrapper extends BaseComponent {
	/**
	 *
	 * @type {string}
	 */
	static CLASS = 'LastLoginComponentWrapper';


	/**
	 * @static
	 * @type {string}
	 */
	static DIRECTIVE = 'cgp-directive-lastlogin';


	/**
	 * last login component provided by the regulation class
	 * @type {null}
	 * @private
	 */
	_lastLoginComponent = null;

	init(params) {
		super.init(params);
		this._lastLoginComponent = this.serviceFactory.regulationService().getRegulation().getLastLoginComponent(params);
	}

	start() {
		this._lastLoginComponent.start();
		this.appendChildComponent(this._lastLoginComponent);
	}

	shutDown() {
		//TODO should be removed after directives UT refactor
		this.logger.debug('ShutDown LastLoginComponentWrapper');
	}
}